export const getOrganization = state => {
    const { organization } = state.organizations;
    return organization;
};
export const getOrganizationSlug = state => {
    const { organization } = state.organizations;
    const { slug } = organization;
    return slug;
};
